/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
/**
 * Text saves certain text styling as a string in the format `12px`, and doesn't expose the number directly
 * So this method extracts the number from the string if possible and then returns it.
 */
export const removeUnitFromString = (text: string | number, unit: string = `px`): number => {
	if (typeof text === 'number') {
		return text;
	}

	return Number(text.replace(unit, ``));
};
